<template>
	<div class="demand_wrap">
		<div class="demand_conent">
			<div class="content-header">爱设计免费帮你做模板</div>
			<div class="content-form">
				<el-form ref="form" :model="form" :rules="rules" label-width="80px">
					<el-form-item label="需求场景：" prop="scene_id">
						<el-select v-model="form.scene_id" @change="selectChange">
							<el-option
								v-for="item in sceneList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="其他场景：" prop="new_scene_name" v-if="showNewSceneName">
						<el-input
							v-model="form.new_scene_name"
							placeholder="请填写你的其他场景"
						></el-input>
					</el-form-item>
					<el-form-item label="你的行业：" prop="industry">
						<el-input
							v-model="form.industry"
							placeholder="请填写你所在的行业"
						></el-input>
					</el-form-item>
					<el-form-item label="你的职业：" prop="position">
						<el-input v-model="form.position" placeholder="请填写你的职业"></el-input>
					</el-form-item>
					<el-form-item label="需求描述：" prop="description">
						<el-input
							type="textarea"
							v-model="form.description"
							placeholder="请描述你的需求，例如设计主题、用途、风格、颜色等。爱设计最快将于24小时内反馈结果。"
						></el-input>
					</el-form-item>
					<el-form-item class="button">
						<el-button type="primary" @click="onSubmit">提交需求</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import { TemplateCenter } from '@/config/axios/new_api'
export default {
	data() {
		return {
			form: {
				scene_id: '',
				new_scene_name: '',
				industry: '',
				position: '',
				description: '',
				scene_name: '每日一签',
			},
			showNewSceneName: false,
			rules: {
				scene_id: [{ required: true, message: '请选择需求场景', trigger: 'change' }],
				new_scene_name: [{ required: true, message: '请填写其他场景', trigger: 'change' }],
				industry: [{ required: true, message: '请填写行业', trigger: 'change' }],
				position: [{ required: true, message: '请填写职业', trigger: 'change' }],
				description: [{ required: true, message: '请填写备注信息', trigger: 'change' }],
			},
			sceneList: [],
		}
	},
	created() {
		this.getData()
	},
	methods: {
		async getData() {
			let res = await TemplateCenter.sceneList()
			this.sceneList = res.data
		},
		selectChange(id) {
			if (id === 9999) {
				this.showNewSceneName = true
			} else {
				this.showNewSceneName = false
			}
		},
		onSubmit() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					TemplateCenter.demand(this.form)
						.then(res => {
							if (res.status == 1) {
								this.$message.success('提交成功')
							} else {
								this.$message.error(res.error)
							}
						})
						.catch(err => {
							this.$message.error(err.msg)
						})
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.demand_wrap {
	height: 100%;
	box-sizing: border-box;
	background-color: #f9f9fc;
}
.demand_conent {
	width: 801px;
	background-color: #fff;
	margin: 0 auto;
	margin-top: 120px;
	.content-header {
		width: 100%;
		height: 100px;
		background: linear-gradient(129deg, #9db4ff 0%, #7a66ff 100%);
		text-align: center;
		line-height: 100px;
		color: #fff;
		font-size: 26px;
		letter-spacing: 3px;
		user-select: none;
	}
	.content-form {
		width: 615px;
		padding: 80px 0;
		margin: 0 auto;
		::v-deep( .el-form) {
			.el-form-item {
				display: flex;
				.el-form-item__label {
					width: 100px !important;
				}
				.el-form-item__content {
					width: 420px;
					margin-left: 0 !important;
					.el-select {
						width: 100%;
					}
					.el-textarea {
						height: 170px;
						.el-textarea__inner {
							height: 100%;
							resize: none;
							padding: 10px;
						}
					}
				}
			}
			.button {
				justify-content: center;
				margin-top: 40px;
				.el-form-item__content {
					width: 142px;
					.el-button {
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
